import { useEffect, useState } from 'react';

import { FormControlLabel, Switch, Tooltip } from '@mui/material';
import { useFormikContext } from 'formik';

import { useApplicationContext } from 'context/ApplicationContext';
import { Revendedor } from 'pages/revendedor/revendedor/types';

export function RevendedorAprovadoToggle() {
    const { values, setFieldValue } = useFormikContext<Revendedor>();
    const [switchChecked, setSwitchChecked] = useState<boolean>(true);
    const { user } = useApplicationContext();
    const { tipoRevendedor, arquivo } = values;
    const hasFiles = arquivo?.length > 0;
    const hasPermission = ['MASTER', 'SUPORTE_CISS'].includes(user.tipoUsuario.tipoUsuarioEnum);
    const disableToggle = !hasFiles && !hasPermission;

    const handleChangeAprovado = (fgAprovado: boolean): void => {
        setSwitchChecked(fgAprovado);
        setFieldValue('fgAprovado', fgAprovado);
    };

    useEffect(() => {
        if (values.fgAprovado !== switchChecked) {
            handleChangeAprovado(Boolean(values.fgAprovado));
        }
    }, [values.fgAprovado]);

    if (!hasPermission && (!tipoRevendedor || tipoRevendedor?.tipoRevendedorEnum === 'PJ')) return null;

    return (
        <Tooltip
            title={disableToggle ? 'É necessário ter um anexo salvo para poder aprovar' : ''}
            slotProps={{
                tooltip: {
                    sx: {
                        maxWidth: 330,
                    },
                },
            }}
        >
            <FormControlLabel
                control={<Switch checked={switchChecked} disabled={disableToggle} onChange={(e, checked) => handleChangeAprovado(checked)} />}
                label="Aprovado"
            />
        </Tooltip>
    );
}
